<template>
    <div class="mx-auto w-full px-2 sm:px-0 sm:w-max sm:ml-24">
      <section class="border border-sepBorder dark:border-dark.sepBorder text-panelsText dark:text-dark.panelsText bg-tableBG dark:bg-dark.tableBG text-base rounded-lg mt-6 mb-10 p-4 sm:p-8 px-2 sm:px-14 relative">
        <router-view :key="$route.path"></router-view>
      </section>
    </div>
</template>